import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjSettingsDependenciesRoute: InvariantJiraRoute = {
	name: 'arj-settings-dependencies',
	path: '/jira/plans/settings/dependencies',
};
